import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PinterestFilledSvg from "@ant-design/icons-svg/es/asn/PinterestFilled";
import AntdIcon from "../components/AntdIcon";
var PinterestFilled = function PinterestFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PinterestFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PinterestFilled.displayName = 'PinterestFilled';
}
export default /*#__PURE__*/React.forwardRef(PinterestFilled);